@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">{{ state.shipment ? `Wysyłka ${state.shipment.shipmentNumber}` : 'Nowa wysyłka' }}</div>
  </div>

  <div class="card" id="data-card">
    <div class="card-header">
      DANE
    </div>

    @if (state.shipment; as shipment) {
      <div class="field" (dblclick)="startEditing('transport', shipment)" [title]="isPlanned(shipment) ? 'Dwuklik edytuje' : ''">
        <div class="field-label">Transport</div>
        @if (editingField() === 'transport') {
          <input #fieldInput class="field-input" [value]="shipment.transport"
            (keyup.enter)="saveField('transport', fieldInput.value, shipment)" (keyup.escape)="stopEditing()" (blur)="stopEditing()">
        } @else {
          <div class="field-value">{{ shipment.transport }}</div>
        }
      </div>

      <div class="field" (dblclick)="startEditing('plannedDate', shipment)" [title]="isPlanned(shipment) ? 'Dwuklik edytuje' : ''">
        <div class="field-label">Planowana data</div>
        @if (editingField() === 'plannedDate') {
          <input #fieldInput class="field-input" type="date" [value]="shipment.plannedDate ?? ''"
            (change)="saveField('plannedDate', fieldInput.value, shipment)" (keyup.escape)="stopEditing()" (blur)="stopEditing()">
        } @else {
          <div class="field-value text-mono" [class.empty]="!shipment.plannedDate">{{ shipment.plannedDate ? formatDayMonthYear(shipment.plannedDate) : '—' }}</div>
        }
      </div>

      <div class="field">
        <div class="field-label">Status</div>
        <div class="field-value">{{ shipment.statusLabel }}</div>
      </div>

      @if (shipment.shippedAt) {
        <div class="field">
          <div class="field-label">Wysłano</div>
          <div class="field-value text-mono">{{ formatDayMonthYear(shipment.shippedAt.slice(0, 10)) }}</div>
        </div>
      }

      <div class="field">
        <div class="field-label">Utworzono</div>
        <div class="field-value text-mono">{{ formatDayMonthYear(shipment.createdAt.slice(0, 10)) }}</div>
      </div>
    } @else {
      <div class="field">
        <div class="field-label">Transport</div>
        <input #transportInput class="field-input" [value]="draft().transport" placeholder="Nr rejestracyjny, kontener, przewoźnik"
          (input)="updateDraft('transport', transportInput.value)" (keyup.enter)="create()">
      </div>

      <div class="field">
        <div class="field-label">Planowana data</div>
        <input #plannedDateInput class="field-input" type="date" [value]="draft().plannedDate ?? ''"
          (change)="updateDraft('plannedDate', plannedDateInput.value)">
      </div>

      <button class="btn" [disabled]="!canCreate()" (click)="create()">Utwórz wysyłkę</button>
    }
  </div>

  <div class="card" id="items-card">
    <div class="card-header">
      ZAWARTOŚĆ

      @if (state.shipment; as shipment) {
        <div class="card-header-toolbar">
          @if (isPlanned(shipment)) {
            @if (!isEmpty(shipment)) {
              <button class="btn" (click)="ship()" title="Oznacza wysyłkę jako wysłaną; potem zawartość jest tylko do odczytu">Wyślij</button>
            }
          } @else {
            <button class="btn" (click)="unship()" title="Cofa status Wysłana — zawartość znów można zmieniać">Cofnij wysyłkę</button>
          }
        </div>
      }
    </div>

    @if (state.shipment; as shipment) {
      <div class="groups">
        @for (group of shipment.groups; track group.clientOrderId) {
          <div class="group">
            <div class="group-header">
              <a class="group-order" [routerLink]="['/client-orders', group.clientOrderId]">{{ group.clientOrderNumber }}</a>
              <span class="group-client">{{ group.clientName }}</span>
            </div>

            @for (item of group.items; track item.shipmentItemId) {
              <div class="line" [class.editable]="isPlanned(shipment)" (dblclick)="startEditingAmount(item, shipment)" [title]="isPlanned(shipment) ? 'Dwuklik zmienia ilość' : ''">
                <item-photo [attachmentId]="item.primaryPhotoAttachmentId" [label]="item.name"></item-photo>
                <span class="line-name" [title]="item.name">{{ item.name }}</span>

                <span class="line-amount text-mono">
                  @if (editingItemId() === item.shipmentItemId) {
                    <input #amountInput inputmode="decimal" [value]="formatAmountInput(item.amount)"
                      (keyup.enter)="saveAmount(item, amountInput.value)" (keyup.escape)="stopEditingAmount()" (blur)="stopEditingAmount()"> {{ item.unit }}
                  } @else {
                    {{ formatAmount(item.amount, item.unit) }}
                  }
                  <span class="line-ordered">/ {{ formatAmount(item.orderedAmount, item.unit) }}</span>
                </span>

                @if (isPlanned(shipment)) {
                  <button class="btn btn-small" (click)="removeItem(item)" title="Zdejmuje pozycję z wysyłki; ilość wraca do wysłania">Usuń</button>
                } @else {
                  <span></span>
                }
              </div>
            }
          </div>
        } @empty {
          <div class="lines-empty">Brak pozycji — dodaj je z poziomu zamówienia (Dodaj do wysyłki).</div>
        }
      </div>
    } @else {
      <div class="lines-empty">Zapisz dane wysyłki, aby dodać pozycje z zamówień.</div>
    }
  </div>
}
